import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Fa from '../../../utils/Fa';

import './filter-item.css';

const onToggleWrapper = (onToggle) => (e) => onToggle(e.currentTarget.dataset.filter, e);

const FilterItem = ({ opened, label, filterName, children, onToggle }) => (
  <fieldset className="filter-item">
    <legend>
      <button
        className={classNames('filter-item-title', { opened })}
        data-filter={filterName}
        onMouseDown={onToggleWrapper(onToggle)}
      >
        <span>{label}</span>
        <Fa
          icon="angle-down"
          className={classNames('filter-item-arrow', { 'fa-rotate-180': opened })}
        />
      </button>
    </legend>
    <div className={classNames('filter-item-content-wrapper', { opened })}>
      <div className="filter-item-content">{children}</div>
    </div>
  </fieldset>
);

FilterItem.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  opened: PropTypes.bool.isRequired,
  filterName: PropTypes.string.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default FilterItem;
